<template>
  <div :class="['wrapper', 'pt-3xl', css]">
    <template v-if="children.length">
      <component
        v-for="(comp, index) in children"
        :key="comp.type + index"
        :is="comp.type"
        :class="[comp.type !== 'abtn' ? 'inner-wrapper' : '', comp.type === 'h1' ? 'heading' : '']"
        v-bind="comp"
        :size="size"
      >
        <span
          v-if="comp.type === 'h1'"
          :key="'h1' + index"
          v-text="comp.title"
        ></span>
      </component>
    </template>
  </div>
</template>

<script>
export default {
  props: ["children", "css", "size"]
};
</script>

<style lang="stylus" scoped>
.wrapper
  .inner-wrapper
    pad('xl',bottom)
  >>> h1
    pad('s',bottom)
.no-padd-y
  padding-top 0px !important
  padding-bottom 0px !important
</style>
